import { render, staticRenderFns } from "./TendenciaInforme.vue?vue&type=template&id=6f348558&"
import script from "./TendenciaInforme.vue?vue&type=script&lang=js&"
export * from "./TendenciaInforme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports